import type { IStatsAggregates } from '../../models/trainingStatistics';

/**
 * Esporta aggregates come CSV downloadabile.
 * Spec v1.1.1 sez 21 riga 2949: "Excel con tutti i dati raw filtrabili".
 * MVP: CSV semplice multi-sezione apribile con Excel.
 */
export function exportStatsAsCsv(
  aggregates: IStatsAggregates,
  teamId: string,
): void {
  const rows: string[] = [];
  rows.push('LEOPART — Statistiche Allenamento');
  rows.push(`Team,${teamId}`);
  rows.push(`Totale sessioni,${aggregates.totalSessions ?? 0}`);
  rows.push(`Totale blocchi,${aggregates.totalBlocks ?? 0}`);
  rows.push(`Totale minuti,${aggregates.totalMinutes ?? 0}`);
  rows.push('');

  if (aggregates.bySessionPhase && aggregates.bySessionPhase.length > 0) {
    rows.push('=== Distribuzione per fase seduta ===');
    rows.push('phaseId,minuti,percentuale');
    aggregates.bySessionPhase.forEach((p: any) => {
      rows.push(
        `${csvEsc(p.phaseId)},${p.minutes ?? 0},${(p.percentage ?? 0).toFixed(1)}`,
      );
    });
    rows.push('');
  }

  if (aggregates.byDidacticMethod && aggregates.byDidacticMethod.length > 0) {
    rows.push('=== Distribuzione per metodo didattico ===');
    rows.push('methodId,minuti,percentuale');
    aggregates.byDidacticMethod.forEach((m: any) => {
      rows.push(
        `${csvEsc(m.methodId)},${m.minutes ?? 0},${(m.percentage ?? 0).toFixed(1)}`,
      );
    });
    rows.push('');
  }

  if (
    aggregates.byTechnicalObjective &&
    aggregates.byTechnicalObjective.length > 0
  ) {
    rows.push('=== Obiettivi tecnici ===');
    rows.push(
      'objectiveId,minuti,percentuale,analitico,globale,situazionale,partita_tema,partita_libera',
    );
    aggregates.byTechnicalObjective.forEach((o: any) => {
      const bm = o.byMethod ?? {};
      rows.push(
        [
          csvEsc(o.objectiveId),
          o.minutes ?? 0,
          (o.percentage ?? 0).toFixed(1),
          bm.analytical ?? 0,
          bm.global ?? 0,
          bm.situational ?? 0,
          bm.themed_game ?? 0,
          bm.free_game ?? 0,
        ].join(','),
      );
    });
    rows.push('');
  }

  if (
    aggregates.byTacticalObjective &&
    aggregates.byTacticalObjective.length > 0
  ) {
    rows.push('=== Obiettivi tattici ===');
    rows.push('objectiveId,minuti,percentuale');
    aggregates.byTacticalObjective.forEach((o: any) => {
      rows.push(
        `${csvEsc(o.objectiveId)},${o.minutes ?? 0},${(o.percentage ?? 0).toFixed(1)}`,
      );
    });
  }

  const csv = rows.join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `training-stats-${teamId}-${new Date()
    .toISOString()
    .slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

function csvEsc(v: unknown): string {
  if (v == null) return '';
  const s = String(v);
  if (s.includes(',') || s.includes('"') || s.includes('\n')) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}
